import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Legal from "./pages/Legal";
import { CookieConsent } from "./components/CookieConsent";

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <SmoothScroll />
        <Toaster theme="dark" position="top-center" richColors />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<Legal type="impressum" />} />
          <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
          <Route path="/agb" element={<Legal type="agb" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
